var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top_left_title"},[_vm._t("top_title")],2)}
var staticRenderFns = []

export { render, staticRenderFns }